var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRevisionHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3012_32162)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3012_32162",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 11
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8684 0H0.668434V11H11.8684V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3012_32162)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.16274 0.078125C1.43572 0.078125 1.65701 0.295463 1.65701 0.563562V2.44656L2.44761 1.67007C4.60451 -0.448309 8.09392 -0.448309 10.2508 1.67007C12.4077 3.78844 12.4077 7.21556 10.2508 9.33391C8.09392 11.4524 4.60451 11.4524 2.44761 9.33391C2.2546 9.1444 2.2546 8.83702 2.44761 8.64743C2.64064 8.45784 2.95359 8.45784 3.14661 8.64743C4.91746 10.3867 7.78097 10.3867 9.55181 8.64743C11.3227 6.9082 11.3227 4.09581 9.55181 2.35658C7.78097 0.617352 4.91746 0.617352 3.14661 2.35658L2.33616 3.15255H4.29308C4.56605 3.15255 4.78733 3.36989 4.78733 3.63799C4.78733 3.90609 4.56605 4.12343 4.29308 4.12343H1.16274C0.889769 4.12343 0.66848 3.90609 0.66848 3.63799V0.563562C0.66848 0.295463 0.889769 0.078125 1.16274 0.078125ZM6.76439 2.66712C6.76439 2.39902 6.5431 2.18169 6.27013 2.18169C5.99715 2.18169 5.77586 2.39902 5.77586 2.66712V5.25612C5.77586 5.38486 5.82793 5.50833 5.92063 5.59937L7.56817 7.21749C7.76119 7.40706 8.07414 7.40706 8.26717 7.21749C8.46018 7.02792 8.46018 6.72055 8.26717 6.53098L6.76439 5.05504V2.66712Z",
    fill: "#475569"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3012_32162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 11,
    fill: "white",
    transform: "translate(0.500053)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevisionHistory);
export default __webpack_public_path__ + "static/media/Revision_History.54c68f3291f13a40c0ebdf834d09b02a.svg";
export { ForwardRef as ReactComponent };